/**
 * @generated SignedSource<<01ebc5b9f98345e88b9d9d90bc690482>>
 * @relayHash de7435a919454f9e6d5061b045c73617
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c020d887d7032f230a5440cb7079977514e3cd2e05b7d0e68c86287d363f404f

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraSingleValueFieldOperations = "SET" | "%future added value";
export type JiraUpdateIssueTypeFieldInput = {
  id: string;
  operation: JiraIssueTypeFieldOperationInput;
};
export type JiraIssueTypeFieldOperationInput = {
  id: string;
  operation: JiraSingleValueFieldOperations;
};
export type ui_issueTypeSwitcherWithoutRefetch_Mutation$variables = {
  input: JiraUpdateIssueTypeFieldInput;
};
export type ui_issueTypeSwitcherWithoutRefetch_Mutation$data = {
  readonly jira: {
    readonly updateIssueTypeField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly issueType: {
          readonly avatar: {
            readonly xsmall: string | null | undefined;
          } | null | undefined;
          readonly hierarchy: {
            readonly level: number | null | undefined;
          } | null | undefined;
          readonly id: string;
          readonly issueTypeId: string | null | undefined;
          readonly name: string;
        } | null | undefined;
        readonly issueTypes: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly avatar: {
                readonly xsmall: string | null | undefined;
              } | null | undefined;
              readonly hierarchy: {
                readonly level: number | null | undefined;
              } | null | undefined;
              readonly id: string;
              readonly issueTypeId: string | null | undefined;
              readonly name: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type ui_issueTypeSwitcherWithoutRefetch_Mutation$rawResponse = {
  readonly jira: {
    readonly updateIssueTypeField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly id: string;
        readonly issueType: {
          readonly avatar: {
            readonly xsmall: string | null | undefined;
          } | null | undefined;
          readonly hierarchy: {
            readonly level: number | null | undefined;
          } | null | undefined;
          readonly id: string;
          readonly issueTypeId: string | null | undefined;
          readonly name: string;
        } | null | undefined;
        readonly issueTypes: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly avatar: {
                readonly xsmall: string | null | undefined;
              } | null | undefined;
              readonly hierarchy: {
                readonly level: number | null | undefined;
              } | null | undefined;
              readonly id: string;
              readonly issueTypeId: string | null | undefined;
              readonly name: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type ui_issueTypeSwitcherWithoutRefetch_Mutation = {
  rawResponse: ui_issueTypeSwitcherWithoutRefetch_Mutation$rawResponse;
  response: ui_issueTypeSwitcherWithoutRefetch_Mutation$data;
  variables: ui_issueTypeSwitcherWithoutRefetch_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "issueTypeId"
},
v7 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v8 = {
  "concreteType": "JiraIssueTypeHierarchyLevel",
  "kind": "LinkedField",
  "name": "hierarchy",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "level"
    }
  ]
},
v9 = {
  "concreteType": "JiraIssueType",
  "kind": "LinkedField",
  "name": "issueType",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/)
  ]
},
v10 = {
  "concreteType": "JiraIssueTypeConnection",
  "kind": "LinkedField",
  "name": "issueTypes",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraIssueType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v6/*: any*/),
            (v5/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/)
          ]
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ui_issueTypeSwitcherWithoutRefetch_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraIssueTypeFieldPayload",
            "kind": "LinkedField",
            "name": "updateIssueTypeField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraIssueTypeField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ui_issueTypeSwitcherWithoutRefetch_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraIssueTypeFieldPayload",
            "kind": "LinkedField",
            "name": "updateIssueTypeField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraIssueTypeField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v4/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c020d887d7032f230a5440cb7079977514e3cd2e05b7d0e68c86287d363f404f",
    "metadata": {},
    "name": "ui_issueTypeSwitcherWithoutRefetch_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "b682d6006590d3bb98b914c83c6c65d8";

export default node;
